import type { JSX } from 'solid-js';
import { PageHeader } from '../components/PageHeader';
import { buttonClass } from '../components/ui/Button';
import { t } from '../i18n';
import { orgHref } from '../lib/org';

// Catch-all 404 (mock routeMeta fallback): a bare PageHeader with the miss as
// the title and a CTA back to the repos grid, instead of a blank #root.
export function NotFound(): JSX.Element {
  return (
    <PageHeader
      title={t('not_found.message')}
      actions={
        <a class={buttonClass()} href={orgHref('/repos')}>
          {t('not_found.cta')}
        </a>
      }
    />
  );
}
